
import React, { Component } from "react";
import { Modal } from "react-bootstrap";
import Navbar from "../../../components/Navbar.js";
import Select from "react-select";
import LOGO from "../../../assets/images/logo.png";
import SignatureCanvas from 'react-signature-canvas';
import Pagination from '@mui/material/Pagination';
import {
    locale,
    tokens,
    select_style,
    required,
    // alert
    success,
    success_url,
    alert,
    alert_url,
    // function
    logout,
    number_zero,
    format_date,
    toFixed,
    total,
    validate,
    random_charactor,
    float,
    // api
    GET,
    POST,
    PUT,
    DELETE,
    error_message,
    // storage
    removeStorage,
    getStorage,

    validate_email,
    validate_th,
    validate_en,
    validate_en_number,

    LinktoBase64,
    // component
    DatePicker,

    report_01
} from "../../../components/CustomComponent.js";

import "../../../components/global.js";
import "../../../assets/css/bootstrap.css";
import "../../../assets/css/index.css";

export default class Dashboard extends Component {
    constructor(props) {
        super(props)
        this.state = {
            modal_delete: false,
            modal_detail: false,

            loading: false,
            data: null,
            page: 1,
            data_search: "",

            quotation_number: "",
            quotation_id: "",
            filter_status: "",
            date: "",

            history_list: []
        }
    }
    async componentDidMount() {
        this.Get();
    }
    Get = async () => {
        this.setState({ loading: true });
        let body = {
            page: this.state.page,
            data_search: this.state.data_search,
            quotation_id: "",
            type: "",
            filter_status: this.state.filter_status,
            date: this.state.date ? format_date(this.state.date, "dd/mm/yyyy", "en") : ""
        }
        let result = await GET(tokens, "v1/TH/quotation/list/" + getStorage("branch").branch_id, body);
        if (result && result.status) {
            console.log(result);
            this.setState({ data: result });
        }
        this.setState({ loading: false });
    }
    GetById = async (id) => {
        let body = {
            page: 0,
            data_search: "",
            quotation_id: id
        }
        let result = await GET(tokens, "v1/TH/quotation/list/" + getStorage("branch").branch_id, body);
        if (result && result.status) {
            console.log("GetById:", result.data);
            report_01(result.data);
        }
    }
    Delete = async () => {
        this.setState({ loading: true });
        let result = await DELETE(tokens, "v1/TH/quotation/delete/" + this.state.quotation_id, null);
        if (result && result.status) {
            success_url("/sale/list-quotation")
        }
        this.setState({ loading: false });
    }
    render() {
        return (
            <div className="w-100 min-vh-100 fade-in">
                {this.state.loading && (<div className="spinner-container"> <div className="loading-spinner"></div> </div>)}
                <Navbar page1="หน้าหลัก" page2="ระบบขาย" page3="ใบเสนอราคา" />
                {/* BODY */}
                <div className="body bg-light min-vh-100">
                    <div className="p-3">
                        {/* หัวข้อ และ ปุ่มเพิ่ม */}
                        <div className="d-flex mx-0 align-items-center justify-content-between test mb-2 flex-wrap">
                            <h3 className="mb-2"><b>ใบเสนอราคา</b></h3>
                            <button className="btn btn-orange" onClick={() => { window.location.href = "/sale/quotation/create" }}>
                                + สร้างใบเสนอราคา
                            </button>
                        </div>
                        <div className="w-100 card border-0">
                            <div className="d-flex flex-wrap mx-0 px-3 pt-3">
                                <input
                                    className="form-control wpx-250 bg-contain border-0 mx-1 mb-2"
                                    type="text"
                                    placeholder=""
                                    onChange={(e) => { this.setState({ data_search: e.target.value }) }}
                                    onKeyUp={(e) => {
                                        if (e.key === "Enter") {
                                            this.setState({ page: 1 });
                                            setTimeout(() => {
                                                this.Get();
                                            }, 10);
                                        }
                                    }}
                                    value={this.state.data_search}
                                />
                                <select className="form-control wpx-250 bg-contain border-0 mx-1 mb-2"
                                    onChange={(e) => {
                                        this.setState({ filter_status: e.target.value, page: 1 })
                                        setTimeout(() => {
                                            this.Get();
                                        }, 10);
                                    }}
                                    value={this.state.filter_status}>
                                    <option value="">สถานะ</option>
                                    <option value="1">รออนุมัติ</option>
                                    <option value="2">อนุมัติ</option>
                                    <option value="3">ไม่อนุมัติ</option>
                                    <option value="4">สำเร็จ</option>
                                    <option value="5">เปิดใบเสร็จแล้ว</option>
                                    <option value="6">ปิดบิล</option>
                                </select>
                                <div className="wpx-250 mx-1">
                                    <DatePicker
                                        className="form-control bg-contain border-0 mb-2"
                                        placeholder="พิมพ์คำค้นหา..."
                                        value={this.state.date}
                                        onChange={(e) => {
                                            this.setState({ date: e, page: 1 })
                                            setTimeout(() => {
                                                this.Get();
                                            }, 10);
                                        }}
                                    />
                                </div>
                                <button className="btn btn-orange mx-1 mb-2" onClick={() => {
                                    this.setState({ page: 1 });
                                    setTimeout(() => {
                                        this.Get();
                                    }, 10);
                                }}>
                                    ค้นหา
                                </button>
                                <button className="btn btn-outline-orange mx-1 mb-2" onClick={() => {
                                    this.setState({ page: 1, data_search: "", filter_status: "", date: "" });
                                    setTimeout(() => {
                                        this.Get();
                                    }, 10);
                                }}>
                                    รีเซ็ต
                                </button>
                            </div>
                            <div className="table-responsive">
                                <table className="table table-borderless table-striped" style={{ marginBottom: 200 }}>
                                    <thead className="bg-primary">
                                        <tr>
                                            <th className="text-center text-white">วันที่</th>
                                            <th className="text-center text-white">เลขที่เอกสาร</th>
                                            <th className="text-left text-white">ชื่อลูกค้า</th>
                                            <th className="text-end text-white">ยอดรวมสุทธิ</th>
                                            <th className="text-center text-white">สถานะ</th>
                                            <th className="text-center text-white">จัดการ</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {this.state.data && this.state.data.data.map((item, index) => (
                                            <tr key={index}>
                                                <td className="text-center">{item.datetime_create ? format_date(item.datetime_create, "dd/mm/yyyy") : "-"}</td>
                                                <td className="text-center">{item.quotation_number ? item.quotation_number : "-"}</td>
                                                <td className="text-left">{item.full_name ? item.full_name : "-"}</td>
                                                <td className="text-end">{item.net_total_amount ? toFixed(item.net_total_amount) : "0.00"}</td>
                                                <td className="text-center">{item.quotation_status === 1 ? "รออนุมัติ" :
                                                    item.quotation_status === 2 ? "อนุมัติ" :
                                                        item.quotation_status === 3 ? "ไม่อนุมัติ" :
                                                            item.quotation_status === 4 ? "สำเร็จ" :
                                                                item.quotation_status === 5 ? "เปิดใบเสร็จแล้ว" :
                                                                    item.quotation_status === 6 ? "ปิดบิล" :
                                                                        "-"}</td>
                                                <td className="text-center">
                                                    <div className="dropdowns">
                                                        <span className="dropbtns pointer">
                                                            <div className="pointer wpx-30 hpx-30 rounded bg-primary-light mx-1 d-flex justify-content-center align-items-center">
                                                                <label className="pointer icon text-primary p-2">{"\uf141"}</label>
                                                            </div>
                                                        </span>
                                                        <div className="dropdowns-content wpx-250 bg-white text-start">
                                                            <a className="pointer" onClick={() => { this.GetById(item.quotation_id) }}>
                                                                <label className="icon mx-2">{"\uf02f"}</label>พิมพ์เอกสาร
                                                            </a>
                                                            {item.quotation_status !== 6 && (
                                                                <a className="pointer" onClick={() => { window.location.href = "/sale/quotation/update?id=" + item.quotation_id }}>
                                                                    <label className="icon mx-2">{"\uf304"}</label>แก้ไขข้อมูล
                                                                </a>
                                                            )}
                                                            {item.quotation_status !== 6 && (
                                                                <a className="pointer" onClick={() => { this.setState({ modal_detail: true, history_list: item.history_list }) }}>
                                                                    <label className="icon mx-2">{"\uf1da"}</label>ประวัติ
                                                                </a>
                                                            )}
                                                            {item.quotation_status === 1 && (
                                                                <a className="pointer" onClick={() => { this.setState({ modal_delete: true, quotation_number: item.quotation_number, quotation_id: item.quotation_id }) }}>
                                                                    <label className="icon mx-2">{"\uf1f8"}</label>ลบข้อมูล
                                                                </a>
                                                            )}
                                                        </div>
                                                    </div>
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                                {/* pagination */}
                                {this.state.data && (
                                    <div className="d-flex flex-wrap justify-content-between w-100 px-3 mt-3">
                                        <label>
                                            แสดง {this.state.data.end_index} รายการ จาก {this.state.data.count} รายการ
                                        </label>
                                        <Pagination
                                            count={this.state.data.page_number}
                                            page={this.state.data.page}
                                            color="primary"
                                            showFirstButton
                                            shape="rounded"
                                            showLastButton
                                            onChange={(event, value) => {
                                                this.setState({ page: value })
                                                setTimeout(() => { this.Get() }, 5)
                                            }} />
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
                {/* ลบข้อมูล */}
                <Modal show={this.state.modal_delete} onHide={() => { this.setState({ modal_delete: false }) }}>
                    <Modal.Header> <Modal.Title> <b>ต้องการลบใบเสนอราคา</b> </Modal.Title> </Modal.Header>
                    <Modal.Body>
                        <label>
                            ท่านต้องการลบใบเสนอราคา “{this.state.quotation_number}”
                        </label>
                    </Modal.Body>
                    <Modal.Footer>
                        <label className="mb-2 w-100">
                            หมายเหตุ ไม่สามารถกู้คืนได้
                        </label>
                        <div className="w-100 d-flex">
                            <div className="w-50 pe-1">
                                <button className="btn btn-danger w-100" onClick={() => { this.Delete() }}>
                                    ลบ
                                </button>
                            </div>
                            <div className="w-50 ps-1">
                                <button className="btn btn-outline-danger w-100" onClick={() => { this.setState({ modal_delete: false }) }}>
                                    ยกเลิก
                                </button>
                            </div>
                        </div>
                    </Modal.Footer>
                </Modal>
                {/* ลบข้อมูล */}
                <Modal show={this.state.modal_detail} onHide={() => { this.setState({ modal_detail: false }) }}>
                    <Modal.Header> <Modal.Title> <b>ประวัติ</b> </Modal.Title> </Modal.Header>
                    <Modal.Footer>
                        <table className="table table-borderless table-striped" style={{ marginBottom: 200 }}>
                            <thead className="bg-primary">
                                <tr>
                                    <th className="text-center text-white">วันที่</th>
                                    <th className="text-center text-white">เลขที่เอกสาร</th>
                                    <th className="text-center text-white">จัดการ</th>
                                </tr>
                            </thead>
                            <tbody>
                                {this.state.history_list && this.state.history_list.map((item, index) => (
                                    <tr key={index}>
                                        <td className="text-center">{item.datetime_update ? format_date(item.datetime_update, "dd/mm/yyyy hh:mm:ss") : "-"}</td>
                                        <td className="text-center">{item.quotation_number ? item.quotation_number : "-"}</td>
                                        <td className="text-center">
                                            <div className="pointer wpx-30 hpx-30 rounded bg-cyan-light mx-1 d-flex justify-content-center align-items-center"
                                                onClick={() => { window.location.href = "/sale/quotation/update?history_id=" + item.history_id }}>
                                                <label className="pointer icon text-cyan p-2">{"\uf15b"}</label>
                                            </div>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                        <div className="w-50 ps-1 mx-auto">
                            <button className="btn btn-outline-danger w-100" onClick={() => { this.setState({ modal_detail: false }) }}>
                                ปิดหน้าต่าง
                            </button>
                        </div>
                    </Modal.Footer>
                </Modal>
            </div >
        )
    }
}
